import { render, staticRenderFns } from "./LabelEditable.vue?vue&type=template&id=02bf9583&"
import script from "./LabelEditable.vue?vue&type=script&lang=js&"
export * from "./LabelEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports